import React from 'react';
import { Button, Input, Modal, ModalHeader, ModalFooter, ModalBody, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { ButtonGroup, DropdownToggle, DropdownMenu, DropdownItem, ButtonDropdown } from 'reactstrap';
import Viewer from '../Viewer'
import PrintDocumentModal from './PrintDocumentModal'
import PrintIcon from '@mui/icons-material/PrintOutlined'
import EmailIcon from '@mui/icons-material/EmailOutlined'
import DownloadIcon from '@mui/icons-material/CloudDownloadOutlined'
import EmailDocumentModal from './EmailDocumentModal';
import { Flag } from 'flagger/react';
import DocumentAnnotations from '../DocumentAnnotiations';
import AddAnnotationToDocumentModal from './AddDocumentAnnotaionModal';

function getFileKindFromMeta(fileData) {
  const name = (fileData?.filename || '').toLowerCase();
  const type = (fileData?.contentType || '').toLowerCase();

  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (type.startsWith('image/') || /\.(png|jpe?g|gif|webp|bmp|svg)$/.test(name)) return 'image';
  if (type.startsWith('text/') || /\.(txt|json|csv|log|md)$/.test(name)) return 'text';
  if (name.endsWith('.msg') || type === 'application/vnd.ms-outlook') return 'msg';
  return 'unsupported';
}

class ViewDocumentModal extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            error: false,
            numPages: null,
            pageNumber: 1,
            activeIndex: 0,
            pdfFile: null,
            fileType: null,
            scale: 1.5,
            dropdownOpen: false,
            printModal: false,
            emailModal: false,
            popoverOpen: false,
            docitems: [],
            searchValue: "",
            matchedElements: [],
            increaseDisabled: false,
            decreaseDisabled: true,
            annotationsVisible: false,
            addAnnotationModalVisible: false,
            fileBase64: null,
            fileData: null
        }

        this.prevPage = this.prevPage.bind(this);
        this.nextPage = this.nextPage.bind(this);
        this.toggleDropDown = this.toggleDropDown.bind(this);
        this.gotoPage = this.gotoPage.bind(this);
        this.increaseSize = this.increaseSize.bind(this);
        this.decreaseSize = this.decreaseSize.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.togglePrintModal = this.togglePrintModal.bind(this);
        this.numPagesChange = this.numPagesChange.bind(this)
        this.renderPDFDocument = this.renderPDFDocument.bind(this)
    }

    componentDidMount() {
        this.renderPDFDocument(this.props.document)
    }

    componentDidUpdate(prevProps) {
        if (this.props.document !== prevProps.document)
            this.renderPDFDocument(this.props.document)
    }

    renderPDFDocument(id) {
        fetch(window.location.protocol + '//' + window.location.host + '/api/archive/portfolio?_id=' + id + '&requireFile=true&getFile=true')
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        fileBase64: result.fileBase64,
                        fileData: result.fileData,
                        numPages: null,
                        pageNumber: 1
                    })
                })
            .catch(error => {
                console.error(error);
            });
    }

    downloadFile = () => {
        const a = document.createElement('a');
        a.href = `/api/archive/download-file?id=${this.props.document}`;
        a.download = '';
        document.body.appendChild(a);
        a.click();
        a.remove();
    };


    toggleDropDown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    prevPage() {
        if (getFileKindFromMeta(this.state.fileData) !== 'pdf') return;
        const number = (this.state.pageNumber || 1) - 1;
        if (number > 0) {
            this.setState({ pageNumber: number, matchedElements: [], searchValue: '' });
        }
    }

    nextPage() {
        if (getFileKindFromMeta(this.state.fileData) !== 'pdf') return;
        const number = (this.state.pageNumber || 1) + 1;
        if (this.state.numPages && number <= this.state.numPages) {
            this.setState({ pageNumber: number, matchedElements: [], searchValue: '' });
        }
    }

    gotoPage(page) {
        this.setState({
            pageNumber: page
        })
    }

    increaseSize() {
        if (getFileKindFromMeta(this.state.fileData) !== 'pdf') return;
        const scale = this.state.scale + 0.5;
        this.setState({
            scale: Math.min(2, scale),
            decreaseDisabled: scale <= 1,
            increaseDisabled: scale >= 2
        });
    }

    decreaseSize() {
        if (getFileKindFromMeta(this.state.fileData) !== 'pdf') return;
        const scale = this.state.scale - 0.5;
        this.setState({
            scale: Math.max(1, scale),
            increaseDisabled: scale >= 2,
            decreaseDisabled: scale <= 1
        });
    }

    toggleAnnotationsVisible = () => {
        this.setState({ annotationsVisible: !this.state.annotationsVisible })
    }

    updateInputValue(evt) {
        let page = 0
        this.setState({
            searchValue: evt.target.value
        })

        if (this.state.searchValue === '') {
            this.setState({
                matchedElements: [],
            })
        }
        /*
        this.state.docitems.forEach(element => {
            page++
            element.forEach(el => {
                if(el.str == evt.target.value)
                {
                    this.state.matchedElements.push({height:el.height,width:el.width,transform:el.transform,pageNumber:page})
                }
            })
        })*/
    }

    togglePrintModal() {
        this.setState({
            printModal: !this.state.printModal,
            popoverOpen: false
        });
    }

    toggleDocumentAnnotationModal = () => {
        this.setState({
            addAnnotationModalVisible: !this.state.addAnnotationModalVisible
        })
    }

    numPagesChange(num) {
        this.setState(s => ({
            numPages: num,
            pageNumber: Math.min(s.pageNumber || 1, num || 1)
        }));
    }


    render() {

        const { pageNumber, numPages, matchedElements, scale, increaseDisabled, decreaseDisabled } = this.state;
        const { fileBase64, fileData } = this.state;
        const kind = getFileKindFromMeta(fileData);
        const isPdf = kind === 'pdf';
        const pagingDisabled = !isPdf || !numPages || numPages <= 1;
        const printIcon = <PrintIcon fontSize={'inherit'} style={{ fontSize: '1rem' }} />;
        const emailIcon = <EmailIcon fontSize={'inherit'} style={{ fontSize: '1rem' }} />;
        const downloadIcon = <DownloadIcon fontSize={'inherit'} style={{ fontSize: '1rem' }} />;
        const dropdownitems = []
        if (isPdf && Number.isFinite(numPages) && numPages > 0) {
            for (let i = 1; i <= numPages; i++) {
                dropdownitems.push(
                <DropdownItem key={i} onClick={() => this.gotoPage(i)}>{i}</DropdownItem>
                );
            }
        }
        let highlighted = []
        let disabled = false
        let pages = []
        let printDocumentModal = {}
        let emailDocumentModal = {}
        let addDocumentAnnotationModal = {};


        if (numPages === 1) {
            disabled = true
        }

        if (this.state.printModal)
            printDocumentModal = <PrintDocumentModal modal={this.state.printModal} refresh={this.props.refresh} toggle={this.togglePrintModal} document={this.props.name} file={this.props.file} />
        else
            printDocumentModal = <div />

        if (this.state.emailModal)
            emailDocumentModal = <EmailDocumentModal modal={this.state.emailModal} refresh={this.props.refresh} toggle={() => this.setState({ emailModal: !this.state.emailModal })} document={this.props.name} file={this.props.file} />
        else
            emailDocumentModal = <div />

        if (this.state.addAnnotationModalVisible)
            addDocumentAnnotationModal = <AddAnnotationToDocumentModal visible={this.state.addAnnotationModalVisible} toggle={this.toggleDocumentAnnotationModal} id={this.props.file._id} />
        else
            addDocumentAnnotationModal = <div />

        return (
            <Modal isOpen={this.props.modal} toggle={() => this.props.toggle()} className='modal-dialog'>
                <ModalHeader toggle={() => this.props.toggle()}>Document: {this.props.name} {this.props.fileType}
                    {/* <header class="s-h2-head">Document: {this.props.name}</header> */}
                    <br />
                    <Row style={{ marginTop: '20px', width: '900px' }}>
                        <Col md={8}>
                            <ButtonGroup>
                                <UncontrolledTooltip placement="bottom" target="printButton">
                                    Send Document to Printer
                                </UncontrolledTooltip>
                                <Button id='printButton' color="primary" className="navbtn s-fonticon-btn btn btn-primary" onClick={this.togglePrintModal}>{printIcon}</Button>
                                <UncontrolledTooltip placement="bottom" target="emailButton">
                                    Email Document
                                </UncontrolledTooltip>
                                <Button id='emailButton' color="primary" className="navbtn s-fonticon-btn btn btn-primary" onClick={() => this.setState({ emailModal: !this.state.emailModal })}>{emailIcon}</Button>
                                <UncontrolledTooltip placement="bottom" target="downloadButton">
                                    Download
                                </UncontrolledTooltip>
                                <Button id="downloadButton" color="primary" className="navbtn s-fonticon-btn btn btn-primary" onClick={() => this.downloadFile()}>{downloadIcon}</Button>
                                <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" disabled={!isPdf || pagingDisabled} onClick={this.prevPage}></Button>
                                <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropDown}>
                                    <DropdownToggle color="primary" className="navbtn s-fonticon-btn btn btn-primary" disabled={!isPdf} caret>
                                        {isPdf ? <>Page {pageNumber} / {numPages || 1}</> : <>No paging</>}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {dropdownitems}
                                    </DropdownMenu>
                                </ButtonDropdown>
                                <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" disabled={!isPdf || pagingDisabled} onClick={this.nextPage}></Button>
                                <br />
                                <ButtonGroup>
                                    <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" disabled={!isPdf || increaseDisabled} onClick={this.increaseSize}></Button>
                                    <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" disabled={!isPdf || decreaseDisabled} onClick={this.decreaseSize}></Button>
                                </ButtonGroup>
                                <ButtonGroup>
                                    <Input className="searchinput" value={this.state.searchValue} onChange={this.updateInputValue} id="search_box" type="text" placeholder="Type to Search Document..." />
                                </ButtonGroup>
                            </ButtonGroup>
                        </Col>
                        <Col md={4}>
                            {isPdf && (
                                <ButtonGroup>
                                <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" onClick={this.toggleAnnotationsVisible}></Button>
                                <Button color="primary" className="navbtn s-fonticon-btn btn btn-primary" onClick={this.toggleDocumentAnnotationModal}></Button>
                                </ButtonGroup>
                            )}
                        </Col>
                    </Row>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={isPdf && this.state.annotationsVisible ? 9 : 12}>
                            <Viewer
                                fileBase64={fileBase64}
                                fileData={fileData}
                                pageNumber={pageNumber}
                                header
                                searchTextValue={this.state.searchValue}
                                scale={scale}
                                numberOfPagesChange={this.numPagesChange}
                            />
                        </Col>
                        {isPdf && this.state.annotationsVisible && (
                            <Col md={3}>
                                <DocumentAnnotations id={this.props.document} />
                            </Col>
                        )}
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={() => this.props.toggle()}>Cancel</Button>
                </ModalFooter>
                {addDocumentAnnotationModal}
                {printDocumentModal}
                {emailDocumentModal}
            </Modal>
        );
    }
}

export default ViewDocumentModal;